import { useState, useEffect } from 'react'
// import { toast } from 'react-toastify';

export const useFetchConsigningAuthorities = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataConsingningAuthories, setDataConsigningAuthorities] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchConsigningAuthorities, setLoadingFetchConsigningAuthorities ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-consigning-authorities`)
            // console.log('[useFetchData][useFetchConsigningAuthorities] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchConsigningAuthorities(true)
        fetchData()
            .then((resp) => {
                setDataConsigningAuthorities(resp.rows)
                setLoadingFetchConsigningAuthorities(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchConsigningAuthorities(false)
            })
    }, [execute])

    return { dataConsingningAuthories, loadingFetchConsigningAuthorities, executeFetch }

}

export const useFetchTariff = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataTariff, setDataTariff] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchTariff, setLoadingFetchTariff ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-tariff`)
            // console.log('[useFetchData][useFetchTariff] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchTariff(true)
        fetchData()
            .then((resp) => {
                setDataTariff(resp.rows)
                setLoadingFetchTariff(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchTariff(false)
            })
    }, [execute])

    return { dataTariff, loadingFetchTariff, executeFetch }

}

export const useFetchLocations = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataLocations, setDataLocations] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchLocations, setLoadingFetchLocations ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-enabled-locations`)
            // console.log('[useFetchData][useFetchLocations] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchLocations(true)
        fetchData()
            .then((resp) => {
                setDataLocations(resp.rows)
                setLoadingFetchLocations(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchLocations(false)
            })
    }, [execute])

    return { dataLocations, loadingFetchLocations, executeFetch }

}

export const useFetchAllVehicleReception = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataVehicleReception, setDataVehiclesReception] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllVehicleReception, setLoadingFetchAllVehicleReception ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-all-vehicle-reception`)
            // console.log('[useActions][useFetchAllVehicleReception] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllVehicleReception(true)
        fetchData()
            .then((resp) => {
                setDataVehiclesReception(resp.rows)
                setLoadingFetchAllVehicleReception(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllVehicleReception(false)
            })
    }, [execute])

    return { dataVehicleReception, loadingFetchAllVehicleReception, executeFetch }

}

export const useFetchSpecificVehicleReception = ({marvarApi, dispatch, onLogout, Forms, Helpers, pdfManager, user}) => {

    const { FormScreen } = Forms
    const { setFormState } = FormScreen

    const defaultParams = {
        idreception: '',
        printExitPass: {
            flag: false,
            titularTextToAdd: '',
            observationsToAdd: ''
        },
        printReturnCertificate: {
            flag: false,
            nameToReturnToAdd: '',
            addressToAdd: '',
            phoneToAdd: ''
        },
    }
    const defaultBase64 = {
        docName: '',
        docBase64: ''
    }
    
    const [ loadingFetchSpecificRate, setLoadingFetchSpecificRate ] = useState(false)
    const [paramsToSearch, setParamsToSearch] = useState(defaultParams)
    const [exitPassReportBase64, setExitPassReportBase64] = useState(defaultBase64)
    const [returnCertificateReportBase64, setReturnCertificateReportBase64] = useState(defaultBase64)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setParamsToSearch(defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal/fetch-specific-vehicle-reception/${paramsToSearch.idreception}`)
            console.log('[useFetchData][useFetchSpecificVehicleReception] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idreception > 0 ){
            setLoadingFetchSpecificRate(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idreception: rows[0].idreception || '',
                        idauthority: rows[0].idauthority || '',
                        idrate: rows[0].idrate || '',
                        idlocation: rows[0].idlocation || '',
                        vehicle_placa: rows[0].vehicle_placa || '',
                        vehicle_marca: rows[0].vehicle_marca || '',
                        vehicle_linea: rows[0].vehicle_linea || '',
                        vehicle_color: rows[0].vehicle_color || '',
                        vehicle_modelo: rows[0].vehicle_modelo || '',
                        vehicle_chasis: rows[0].vehicle_chasis || '',
                        vehicle_motor: rows[0].vehicle_motor || '',
                        jsonRate: JSON.stringify({
                            idrate: rows[0].idrate || '',
                            costo:  rows[0].info_rate || ''
                        }),
                        info_rate: rows[0].info_rate || '',
                        info_numero_diligencia: rows[0].info_numero_diligencia || '',
                        info_numero_proceso: rows[0].info_numero_proceso || '',
                        info_cliente: rows[0].info_cliente || '',
                        info_dpi: rows[0].info_dpi || '',
                        info_motivo_recepcion: rows[0].info_motivo_recepcion || '',
                        info_tiene_llaves: rows[0].info_tiene_llaves || '',
                        info_observaciones: rows[0].info_observaciones || '',
                        info_fecha_ingreso: rows[0].info_fecha_ingreso || '',
                        info_flag_cancelado: rows[0].info_flag_cancelado || '',
                        queryDate: rows[0].queryDate || '',
                        queryDateInLetters: rows[0].queryDateInLetters || '',
                        idrecibo: rows[0].idrecibo || 0
                    }))

                    if (paramsToSearch?.printExitPass?.flag === true){
                        console.log('imprimiendo PDF')
                        const base64 = Helpers.drawExitPassDocument(
                            pdfManager,
                            {
                                ...resp.rows[0],
                                titularTextToAdd: paramsToSearch.printExitPass?.titularTextToAdd || '',
                                observationsToAdd: paramsToSearch.printExitPass?.observationsToAdd || '',
                                user: user
                            }
                        )
                        setExitPassReportBase64(base64)
                    }
                    
                    if (paramsToSearch.printReturnCertificate?.flag === true){
                        console.log('imprimiendo PDF')
                        const base64 = Helpers.drawReturnCertificateDocument(
                            pdfManager,
                            {
                                ...resp.rows[0],
                                nameToReturnToAdd: paramsToSearch.printReturnCertificate?.nameToReturnToAdd || '',
                                addressToAdd: paramsToSearch.printReturnCertificate?.addressToAdd || '',
                                phoneToAdd: paramsToSearch.printReturnCertificate?.phoneToAdd || '',
                                user: user
                            }
                        )
                        setReturnCertificateReportBase64(base64)
                    }

                    setLoadingFetchSpecificRate(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificRate(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificRate, exitPassReportBase64, returnCertificateReportBase64, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchAllFiles = ({marvarApi, dispatch, onLogout}) =>{
    
    const [ paramsToSearch, setParamsToSearch ] = useState({
        idreception: ''
    })

    const [ dataFiles, setDataFiles ] = useState([])
    
    const [ loadingFetchInfoFiles, setLoadingFetchInfoFiles ] = useState(false)
    
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/legal/fetch-all-documents-by-vehicle-reception/${paramsToSearch.idreception}`)
            // console.log('[useFetchData][useFetchAllFiles] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idreception !== '' ){
            setLoadingFetchInfoFiles(true)
            fetchData()
                .then((resp) => {
                    setDataFiles(resp.rows)
                    setLoadingFetchInfoFiles(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoFiles(false)
                })
        }
    }, [execute])

    return {dataFiles, loadingFetchInfoFiles, executeFetch, setParamsToSearch }
}

export const useFetchAllExpenseReception = ({marvarApi, dispatch, onLogout}) => {

    const [ paramsToSearch, setParamsToSearch ] = useState({
        idreception: ''
    })

    const [dataExpenseReception, setDataExpenseReception] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllExpenseReception, setLoadingFetchAllExpenseReception ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-all-expense-reception/${paramsToSearch.idreception}`)
            // console.log('[useFetchData][useFetchAllExpenseReception] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idreception !== '' ){
            setLoadingFetchAllExpenseReception(true)
            fetchData()
                .then((resp) => {
                    setDataExpenseReception(resp.rows)
                    setLoadingFetchAllExpenseReception(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchAllExpenseReception(false)
                })
        }
    }, [execute])

    return { dataExpenseReception, loadingFetchAllExpenseReception, executeFetch, setParamsToSearch }

}

export const useFetchSpecificExpenseReception = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormOtherExpense } = Forms
    const { formState, setFormState } = FormOtherExpense
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificExpenseReception, setLoadingFetchSpecificExpenseReception ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idexpensereception: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal/fetch-specific-expense-reception/${paramsToSearch.idexpensereception}`)
            // console.log('[useFetchData][useFetchSpecificExpenseReception] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idexpensereception > 0 ){
            setLoadingFetchSpecificExpenseReception(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idexpensereception: rows[0].idexpensereception,
                        idreception: rows[0].idreception,
                        idexpense: rows[0].idexpense,
                        costo: rows[0].costo,
                        observation: rows[0].observation
                    }))
                    setLoadingFetchSpecificExpenseReception(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificExpenseReception(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificExpenseReception, setParamsToSearch, executeFetch }

}

export const useFetchOtherExpenses = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataOtherExpenses, setDataOtherExpenses] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchOtherExpenses, setLoadingFetchOtherExpenses ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-other-expenses`)
            // console.log('[useFetchData][useFetchOtherExpenses] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchOtherExpenses(true)
        fetchData()
            .then((resp) => {
                setDataOtherExpenses(resp.rows)
                setLoadingFetchOtherExpenses(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchOtherExpenses(false)
            })
    }, [execute])

    return { dataOtherExpenses, loadingFetchOtherExpenses, executeFetch }

}

export const useFetchServiceTotal = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataTotals, setDataTotals] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchTotals, setLoadingFetchTotals ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-service-total`)
            console.log('[useFetchData][useFetchServiceTotal] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchTotals(true)
        fetchData()
            .then((resp) => {
                setDataTotals(resp.rows)
                setLoadingFetchTotals(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchTotals(false)
            })
    }, [execute])

    return { dataTotals, loadingFetchTotals, executeFetch }

}